import { ActionType } from "../action_types/index"
import { SnackbarAction } from "../actions/index"

export interface State {
   /*  notes: string[] */
    show: any
}

const initialState = {
 /*    notes: [], */
    show: {}
}

export const notesReducer = (state: State = initialState, action: SnackbarAction) => {
    switch (action.type) {
        case ActionType.SNACKBAR_TYPE:
            return {
                ...state,
                show: action.payload
            }

        default:
            return state
    }
}